import { graphql } from '@apollo/react-hoc';
import GetCentralClienteContatosAtivoGql from './GetCentralClienteContatosAtivoGql.graphql';

export const GetCentralClienteContatosAtivoQueryGql = graphql(
  GetCentralClienteContatosAtivoGql,
  {
    name: 'centralClienteContatosAtivo',
  }
);
